<div class="report-view" id="report-view">
    <header class="report-actions" data-html2canvas-ignore>
        <app-report-select-form
            [title]="'reports.compare.simu.shortLabel' | translate"
            [maxCompare]="3"
            [selectGroups]="simulations"
            [years]="years"
            compareType="simu"></app-report-select-form>

        <app-report-export-crac *ngIf="isCrac" [exportType]="exportType"></app-report-export-crac>
    </header>

    <app-report-wrapper [selMode]="reportMode.simu"></app-report-wrapper>
</div>

<div class="mobile-message">
    <p>{{'main.mobileMessage.summary' | translate}}</p>
</div>
